import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { retry } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
@Injectable({ providedIn: 'root' })
export class NotificationService {
	baseUrl: string = environment.API_SERVER;
	constructor(private _http: HttpClient) {}

	getUserApplication(payload) {
		return this._http.get(
			this.baseUrl + `/applications/${payload.applicationId}/users/${payload.appUserId}/configurations/`
		);
	}

	updateAppConfig(payload) {
		return this._http.put(
			this.baseUrl +
				`/applications/${payload.applicationId}/users/${payload.appUserId}/configurations/${payload.configId}/`,
			payload.body,
			{ params: payload.params }
		);
	}

	getAppConfig(payload) {
		return this._http.get(this.baseUrl + '/applications/configurations/');
	}
}
